import { render, staticRenderFns } from "./detailDrawer.vue?vue&type=template&id=f5f34894&scoped=true"
import script from "./detailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./detailDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detailDrawer.vue?vue&type=style&index=0&id=f5f34894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f34894",
  null
  
)

export default component.exports